import { SnippetType } from '@distribute/shared/types';
import { IconMap } from '../../shared/sprite';

export const snippetItemIconByType = {
  [SnippetType.IMAGE]: IconMap.Image01,
  [SnippetType.VIDEO]: IconMap.PlaySquare,
  [SnippetType.FILE]: IconMap.BlankPageSquare,
  [SnippetType.TEXT]: IconMap.TypeSquare,
};

export const FILTER_SNIPPET_ITEMS = {
  allTypes: { glyph: IconMap.Files, label: 'All types' },
  text: { glyph: IconMap.FileCheck03, label: 'Text' },
  image: { glyph: IconMap.FileMinus03, label: 'Image' },
  video: { glyph: IconMap.FileMinus03, label: 'Video' },
  file: { glyph: IconMap.FileMinus03, label: 'File' },
} as const;
